import { render } from "./TrialBalance.vue?vue&type=template&id=f0a17710&scoped=true"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"

import "./TrialBalance.vue?vue&type=style&index=0&id=f0a17710&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a17710"]])

export default __exports__